import { cn } from '@/utils';

import styles from './Button.module.css';

export type ButtonVariant =
  'primary' | 'secondary' | 'accent' | 'outline' | 'ghost' | 'danger' | 'inverted';

export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonStyleOptions {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  className?: string;
}

/**
 * Shared class-name builder so `<button>`, router `<Link>` and `<a>` elements
 * can look identical without one wrapping the other.
 */
export function buttonClassName({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className,
}: ButtonStyleOptions = {}): string {
  return cn(styles.base, styles[variant], styles[size], fullWidth && styles.fullWidth, className);
}

export { styles as buttonStyles };
